import { pluralize } from "@src/helpers/constants";
import {
  AppDispatch,
  getMyOrganization,
  getSubjectList,
  getSubjectListRequest,
  useDynamicSelector,
} from "@src/redux";
import { Button, Dropdown, Menu } from "antd";
import Search from "antd/es/input/Search";
import React from "react";
import { useTranslation } from "react-i18next";
import { BsFilterLeft } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";

const WorkersListHeaderOptions: React.FC = () => {
  const { result: subjectList } = useSelector(getSubjectList);
  const { result: myOrganization } = useSelector(getMyOrganization);
  const { ncdRiskFilter } = useDynamicSelector("ncd_risk_analysis");
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const handleSortMenuChange = (value: any) => {
    dispatch(
      getSubjectListRequest({
        filter: {
          organizationId: ncdRiskFilter?.organizationId,
          gender: ncdRiskFilter?.gender,
        },
        sort: [{ field: value?.key, order: "asc" }],
        pagination: { pageLimit: 35, pageNumber: 1 },
      })
    );
  };
  const handleSearchChange = (event: any) => {
    dispatch(
      getSubjectListRequest({
        filter: {
          organizationId: ncdRiskFilter?.organizationId,
          gender: ncdRiskFilter?.gender,
          searchString: event.target.value,
        },
        sort: [{ field: "name", order: "asc" }],
        pagination: { pageLimit: 35, pageNumber: 1 },
      })
    );
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        overflowY: "auto",
        gap: "10px",
        width: "100%",
      }}
    >
      <div style={{ display: "flex", gap: "20px" }}>
        <div className="reading-count-label">
          {pluralize(myOrganization?.rootOrganization?.subjectLabel || "")}
        </div>
        <div className="reading-count-box">
          {subjectList?.pagination?.totalCount ||
            subjectList?.items?.length ||
            0}
        </div>
      </div>
      <div style={{ display: "flex", gap: "20px" }}>
        <Search onChange={handleSearchChange} />
        <Dropdown
          overlay={
            <Menu onClick={handleSortMenuChange}>
              <Menu.ItemGroup title="Sort by">
                <Menu.Item key="name">Name</Menu.Item>
                {/* {my_organization?.rootOrganization?.subjectKeyList &&
                  my_organization?.rootOrganization?.subjectKeyList?.length >
                    0 &&
                  my_organization?.rootOrganization?.subjectKeyList?.map(
                    (list) => {
                      return <Menu.Item key={list.id}>{list.name}</Menu.Item>;
                    }
                  )} */}
                <Menu.Item key="nextReadingDate">Screening Date</Menu.Item>
              </Menu.ItemGroup>
            </Menu>
          }
          trigger={["click"]}
        >
          <Button icon={<BsFilterLeft />} />
        </Dropdown>
      </div>
    </div>
  );
};

export default WorkersListHeaderOptions;
